import { atom, useAtom } from "jotai";
import { Session, ConnectedLinkedInAccount } from "@/interfaces/auth";
import { atomWithStorage, createJSONStorage } from "jotai/utils";
import { AccountsDisplay, LinkedInAccount } from "@/interfaces/accounts";

const noOpStorage = {
  getItem: (_key: string) => null,
  setItem: (_key: string, _value: string) => {},
  removeItem: (_key: string) => {},
};

// User login session
export const sessionAtom = atom<Session | null>(null);
export const sessionLoadingAtom = atom<boolean>(true);

export const useSession = () => {
  const [session, setSession] = useAtom(sessionAtom);
  const [loading, setLoading] = useAtom(sessionLoadingAtom);

  return { session, setSession, loading, setLoading };
};

// Connected linkedin account
export const connectedLinkedInAccountAtom =
  atomWithStorage<ConnectedLinkedInAccount | null>(
    "capex_connected_li_acc",
    null,
    createJSONStorage(() => sessionStorage),
  );

export const selectedClientAtom = atomWithStorage<string | null>(
  "capex_client",
  "Cambio",
  createJSONStorage(() =>
    typeof window !== "undefined" ? sessionStorage : noOpStorage,
  ),
);

export const reachoutRequestorAccountAtom =
  atomWithStorage<LinkedInAccount | null>(
    "capex_reachoutRequestor",
    null,
    createJSONStorage(() =>
      typeof window !== "undefined" ? sessionStorage : noOpStorage,
    ),
  );
